module.exports = __webpack_public_path__ + "img/area_part3_intro.e53ed83a.png";